import { object } from "prop-types"
import {
  useRegistrationInvoice,
  useInvalidateRegistrationInvoice,
} from "source/registrations/hooks/useRegistrationInvoice"
import { Loading } from "source/shared/components"
import PaymentFormWrapper from "./Payment/PaymentFormWrapper"
import { PaymentHistory } from "./PaymentHistory"

const RegistrationInvoice = ({ registration }) => {
  const invalidateInvoice = useInvalidateRegistrationInvoice(registration.id)
  const { isLoading, data: registrationInvoice = {} } = useRegistrationInvoice(
    registration.id,
    {
      retry: false,
    },
  )

  const {
    total,
    totalRefunded,
    totalPaid,
    hasBalanceDue,
    hasRefundDue,
    balanceDue,
    refundDue,
    payments,
    refunds,
  } = registrationInvoice

  const { allowCreditCardPayments, allowAchPayments } = registration.event

  const handlePaymentSave = () => {
    invalidateInvoice()
    registration.invalidate()
  }

  return (
    <div>
      {isLoading && <Loading />}
      {registrationInvoice && (
        <div className="mt-2 d-f fd-c g-2">
          <div className="d-f ai-c jc-sb fw-500">
            <span>Total</span>
            <span>{total}</span>
          </div>
          {totalPaid && (
            <PaymentHistory payments={payments} totalAmount={totalPaid} />
          )}
          {totalRefunded && (
            <PaymentHistory
              payments={refunds}
              totalAmount={totalRefunded}
              label="Refunds"
            />
          )}
          <div className="d-f ai-c jc-sb fw-500">
            <span>{hasRefundDue ? "Refund" : "Balance"} Due</span>
            <span>{hasRefundDue ? refundDue : balanceDue}</span>
          </div>
        </div>
      )}
      {(allowCreditCardPayments || allowAchPayments) && hasBalanceDue && (
        <PaymentFormWrapper
          registrationInvoice={registrationInvoice}
          registration={registration}
          onPaymentSave={handlePaymentSave}
        />
      )}
    </div>
  )
}

RegistrationInvoice.propTypes = {
  registration: object.isRequired,
}

export default RegistrationInvoice
